import clsx from 'clsx';
import { Card } from './Card';

/**
 * Section — titled content block (Card with a header).
 *
 * Props:
 *   title    - uppercase header label
 *   hint     - small right-aligned hint text
 *   live     - shows pulsing green "Live" indicator on the right
 *   variant  - passed to inner Card (defaults to "subtle")
 *   padding  - passed to inner Card (defaults to "md")
 */
export function Section({
  title,
  hint,
  live      = false,
  children,
  variant   = 'subtle',
  padding   = 'md',
  radius    = 'lg',
  className = '',
}) {
  return (
    <Card variant={variant} padding={padding} radius={radius} className={className}>
      {title && (
        <div className="flex items-center justify-between mb-3 text-xs font-semibold tracking-wider uppercase text-muted">
          <span>{title}</span>
          {live && (
            <span className="inline-flex items-center gap-1 text-2xs font-semibold text-success normal-case tracking-normal">
              <span className="w-1.5 h-1.5 rounded-full bg-success animate-pulse-soft" />
              Live
            </span>
          )}
          {hint && !live && (
            <span className="text-2xs font-medium text-tertiary normal-case tracking-normal">{hint}</span>
          )}
        </div>
      )}
      {children}
    </Card>
  );
}
